var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimple4X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 422,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 149,
    width: 423,
    height: 422
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 168,
    width: 79,
    height: 53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 168,
    width: 79,
    height: 53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 168,
    width: 79,
    height: 53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 470,
    width: 74,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 470,
    width: 74,
    height: 65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 470,
    width: 74,
    height: 65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-108 -149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115 360C115 247.334 206.11 156 318.5 156 430.89 156 522 247.334 522 360 522 472.666 430.89 564 318.5 564 206.11 564 115 472.666 115 360Z",
    fill: "#0F203E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.255 168.422C535.458 193.625 535.458 234.486 510.255 259.689L218.367 551.578C193.164 576.78 152.302 576.78 127.1 551.578L127.1 551.578C101.897 526.375 101.897 485.513 127.1 460.311L418.988 168.422C444.191 143.219 485.053 143.219 510.255 168.422Z",
    fill: "#7B899F",
    fillRule: "evenodd",
    fillOpacity: 0.25098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 505.5C121 477.057 144.281 454 173 454 201.719 454 225 477.057 225 505.5 225 533.943 201.719 557 173 557 144.281 557 121 533.943 121 505.5Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#0F203E",
    fontFamily: "Yu Gothic,Yu Gothic_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 29,
    transform: "translate(148.749 507)"
  }, "MX", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 14,
    x: -20.8267,
    y: 21
  }, "Management")), /*#__PURE__*/React.createElement("path", {
    d: "M413 213C413 184.281 436.281 161 465 161 493.719 161 517 184.281 517 213 517 241.719 493.719 265 465 265 436.281 265 413 241.719 413 213Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#0F203E",
    fontFamily: "Yu Gothic,Yu Gothic_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 29,
    transform: "translate(445.824 214)"
  }, "EX", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 14,
    x: -13.7466,
    y: 21
  }, "Employee")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8561 23.9104C65.1907 23.9067 68.7048 20.3957 68.7122 16.061L68.7122 14.3905C68.5854 10.0536 64.9668 6.64056 60.6299 6.76736 56.4711 6.88893 53.1283 10.2318 53.0067 14.3905L53.0067 16.061C53.0141 20.3931 56.524 23.903 60.8561 23.9104ZM55.3548 14.3905C55.4609 11.3504 58.0115 8.97196 61.0516 9.0781 63.9428 9.17906 66.2631 11.4994 66.3641 14.3905L66.3641 16.061C66.2579 19.1011 63.7073 21.4796 60.6672 21.3734 57.7761 21.2725 55.4558 18.9521 55.3548 16.061Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00645 0 0 1 279 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3794 24.9033 60.3395 24.9033C57.8243 24.8919 55.3427 25.4807 53.1006 26.6208 52.5245 26.9208 52.3007 27.6312 52.6008 28.2074 52.9009 28.7836 53.6113 29.0074 54.1875 28.7072 56.0923 27.7372 58.2019 27.2379 60.3395 27.2514L61.3794 27.2514C67.5918 27.2514 72.6503 31.2767 72.6503 36.2077L72.6503 44.6139C72.6503 45.2623 73.1762 45.788 73.8243 45.788 74.4731 45.788 74.9984 45.2623 74.9984 44.6139L74.9984 36.2278C74.9984 29.9752 68.8866 24.9033 61.3794 24.9033Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00645 0 0 1 279 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6376 23.9104C21.9723 23.9067 25.4863 20.3957 25.4937 16.061L25.4937 14.3905C25.3669 10.0536 21.7483 6.64056 17.4114 6.76736 13.2526 6.88893 9.90979 10.2318 9.78823 14.3905L9.78823 16.061C9.79561 20.3931 13.3055 23.903 17.6376 23.9104ZM12.1296 14.3905C12.2358 11.3504 14.7863 8.97196 17.8265 9.0781 20.7176 9.17906 23.0379 11.4994 23.1389 14.3905L23.1389 16.061C23.0327 19.1011 20.4822 21.4796 17.442 21.3734 14.5509 21.2725 12.2306 18.9521 12.1296 16.061Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00645 0 0 1 279 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8895 28.1772C26.1892 27.6029 25.967 26.8943 25.393 26.5939 23.151 25.4539 20.6694 24.8651 18.1542 24.8765L17.1143 24.8765C9.60709 24.8765 3.49532 29.9484 3.49532 36.1809L3.49532 44.6139C3.49532 45.2623 4.02096 45.788 4.66937 45.788 5.31778 45.788 5.84342 45.2623 5.84342 44.6139L5.84342 36.2278C5.84342 31.2901 10.9019 27.2715 17.1143 27.2715L18.1542 27.2715C20.2918 27.258 22.4014 27.7573 24.3062 28.7273 24.8871 29.0155 25.5916 28.7783 25.8797 28.1974 25.8831 28.1907 25.8863 28.184 25.8895 28.1772Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00645 0 0 1 279 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2468 23.689C44.1776 23.6816 48.175 19.6902 48.1898 14.7595L48.1898 12.8139C48.1898 7.87486 44.1859 3.87101 39.2468 3.87101 34.3078 3.87101 30.3039 7.87486 30.3039 12.8139L30.3039 14.7595C30.3187 19.6902 34.3161 23.6816 39.2468 23.689ZM32.652 12.8005C32.652 9.15827 35.6046 6.2057 39.2468 6.2057 42.8891 6.2057 45.8416 9.15827 45.8416 12.8005L45.8416 14.7595C45.8416 18.4017 42.8891 21.3543 39.2468 21.3543 35.6046 21.3543 32.652 18.4017 32.652 14.7595Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00645 0 0 1 279 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8573 25.2253 38.6363 25.2253C30.0087 25.2253 22.9846 31.0419 22.9846 38.1868L22.9846 47.9684C22.9846 48.6168 23.5102 49.1424 24.1586 49.1424 24.807 49.1424 25.3327 48.6168 25.3327 47.9684L25.3327 38.1868C25.3327 32.3367 31.3035 27.5734 38.6363 27.5734L39.8573 27.5734C47.1901 27.5734 53.161 32.3367 53.161 38.1868L53.161 47.9684C53.161 48.6168 53.6867 49.1424 54.3351 49.1424 54.9835 49.1424 55.5091 48.6168 55.5091 47.9684L55.5091 38.1868C55.5091 31.0419 48.4849 25.2253 39.8573 25.2253Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00645 0 0 1 279 168)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2737 43.8384C61.6039 43.8238 70.777 34.627 70.7625 23.2968 70.748 11.9666 61.5511 2.79347 50.2209 2.80807 38.901 2.82265 29.7321 12.0033 29.7321 23.3232 29.7467 34.6577 38.9393 43.8384 50.2737 43.8384ZM50.2737 5.12054C60.3268 5.12054 68.4764 13.2702 68.4764 23.3232 68.4764 33.3762 60.3268 41.5259 50.2737 41.5259 40.2206 41.5259 32.0711 33.3762 32.0711 23.3232 32.082 13.2747 40.2252 5.13146 50.2737 5.12054Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00386 282 470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3593 35.2359C16.3593 38.3412 18.8767 40.8586 21.982 40.8586 25.0873 40.8586 27.6046 38.3412 27.6046 35.2359 27.6046 32.1306 25.0873 29.6132 21.982 29.6132 18.8781 29.6168 16.3629 32.1321 16.3593 35.2359ZM25.2921 35.2359C25.2921 37.0604 23.8131 38.5395 21.9886 38.5395 20.1641 38.5395 18.685 37.0604 18.685 35.2359 18.685 33.4114 20.1641 31.9323 21.9886 31.9323 23.8131 31.9323 25.2921 33.4114 25.2921 35.2359Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00386 282 470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3214 45.2589C38.5374 44.6699 38.2442 44.0161 37.6607 43.7855L33.1084 42.1734C32.6288 41.9972 32.0904 42.1587 31.787 42.5698 30.9625 43.6734 29.9572 44.6295 28.8137 45.3977 28.3795 45.6837 28.188 46.2233 28.3446 46.7191L29.415 50.32 26.5607 51.4168 24.942 48.0273C24.7268 47.5663 24.237 47.2987 23.7329 47.3666 22.369 47.5628 20.9818 47.527 19.6298 47.2609 19.135 47.1626 18.6339 47.3984 18.3943 47.8423L16.5971 51.1459 13.7891 49.8839 15.0445 46.3359C15.2184 45.8562 15.0573 45.3192 14.648 45.0145 13.5444 44.19 12.5883 43.1847 11.8202 42.0412 11.5352 41.6057 10.9932 41.416 10.4987 41.5788L6.89786 42.6425 5.83411 39.8014 9.25 38.1827C9.71409 37.9709 9.98313 37.4786 9.91071 36.9736 9.71686 35.6093 9.75485 34.2222 10.023 32.8705 10.1213 32.3757 9.88547 31.8746 9.44161 31.635L6.13804 29.8379 7.38018 27.043 10.9282 28.2984C11.408 28.47 11.9436 28.3094 12.2496 27.902 13.069 26.8124 14.065 25.8677 15.1964 25.1071 15.632 24.8222 15.8217 24.2801 15.6589 23.7857L14.5357 20.1848 17.39 19.088 19.0352 22.4643C19.2519 22.9237 19.7405 23.1907 20.2443 23.125 21.6058 22.9255 22.9913 22.9612 24.3407 23.2307 24.8374 23.3299 25.3408 23.0942 25.5829 22.6493L27.8887 18.4075C28.1935 17.8456 27.9849 17.143 27.4229 16.8383 26.861 16.5336 26.1585 16.7422 25.8538 17.3041L23.9443 20.8191C22.8912 20.675 21.8256 20.6462 20.7663 20.7332L19.0418 17.1257C18.7869 16.5784 18.1503 16.3238 17.5882 16.5443L12.732 18.4075C12.1659 18.6241 11.8631 19.2411 12.0382 19.8214L13.1746 23.6602C12.33 24.3023 11.5589 25.0357 10.8754 25.8471L7.09607 24.5257C6.53787 24.3202 5.91479 24.5717 5.65571 25.1071L3.54143 29.8577C3.29888 30.4085 3.5167 31.0534 4.04357 31.3443L7.56518 33.2537C7.42108 34.3068 7.39227 35.3725 7.47929 36.4318L3.87179 38.1761C3.32259 38.4362 3.07295 39.0806 3.30357 39.6429L5.15357 44.4859C5.3825 45.0357 5.99163 45.3217 6.56089 45.1466L10.3996 44.0102C11.0434 44.8533 11.7767 45.6242 12.5866 46.3095L11.2652 50.0887C11.0584 50.6612 11.3336 51.2956 11.8929 51.5357L16.6434 53.65C17.1957 53.8949 17.8435 53.6732 18.13 53.1413L20.0395 49.6196C21.092 49.7703 22.1584 49.7991 23.2175 49.7055L24.9354 53.3196C25.1266 53.7229 25.533 53.9801 25.9793 53.9804 26.1218 53.9802 26.263 53.9533 26.3955 53.9011L31.2518 52.0379C31.8016 51.8089 32.0876 51.1998 31.9125 50.6305L30.7695 46.7918C31.6162 46.1498 32.3895 45.4164 33.0754 44.6048L36.848 45.9263C37.4388 46.1377 38.0908 45.8425 38.3214 45.2589Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00386 282 470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2007 45.7941C53.239 47.8522 51.6017 49.5516 49.5437 49.5899 47.4856 49.6282 45.7862 47.9909 45.7479 45.9329 45.7552 45.2943 45.2435 44.7707 44.605 44.7634 44.6049 44.7634 44.6049 44.7634 44.6048 44.7634L44.6048 44.7634C43.9725 44.7597 43.4558 45.2675 43.4486 45.8998 43.4019 48.9325 45.6189 51.5261 48.622 51.952 48.9105 51.997 49.2021 52.019 49.4941 52.018 52.8329 52 55.525 49.2788 55.5069 45.9399 55.5065 45.8538 55.5042 45.7678 55.5 45.6818 55.4792 45.0509 54.9508 44.5563 54.3199 44.5771 54.3102 44.5774 54.3005 44.5779 54.2909 44.5784 53.6546 44.6139 53.167 45.1576 53.2007 45.7941Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00386 282 470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.565 45.4043 60.7857 44.6246C60.1544 44.4988 59.5406 44.9085 59.4147 45.5397 59.2889 46.171 59.6986 46.7848 60.3298 46.9107L62.9727 47.4525 62.4309 50.0557 59.788 49.5139C59.2597 49.4132 58.7307 49.6858 58.5063 50.1746 58.0523 51.1492 57.4406 52.0422 56.6959 52.8175 56.3209 53.2053 56.266 53.8015 56.5637 54.2512L58.0437 56.4977 55.8304 57.9512 54.3504 55.7048C54.0531 55.2569 53.4876 55.0712 52.9827 55.2555 51.9695 55.6358 50.8997 55.8435 49.8179 55.87 49.2679 55.8808 48.8026 56.2796 48.7079 56.8214L48.1661 59.4643 45.5893 58.8829 46.1311 56.24C46.2369 55.7109 45.9627 55.179 45.4704 54.9582 44.4974 54.4987 43.6049 53.8852 42.8275 53.1413 42.437 52.7708 41.8426 52.7188 41.3937 53.0157L39.1143 54.5023 37.6607 52.2823 39.9005 50.8089C40.3953 50.4053 40.4692 49.6769 40.0656 49.1821 39.7163 48.7539 39.1129 48.6327 38.6254 48.8929L35.4143 51.0071C34.8815 51.3606 34.734 52.0777 35.0839 52.6127L37.8127 56.762C38.1661 57.2947 38.8832 57.4422 39.4182 57.0923L41.8893 55.467C42.4463 55.9178 43.0409 56.3201 43.6666 56.6695L43.0654 59.57C42.9392 60.1952 43.34 60.8053 43.9639 60.9377L48.8334 61.9354C48.9102 61.9447 48.9879 61.9447 49.0646 61.9354 49.6183 61.944 50.1004 61.5589 50.2143 61.017L50.8089 58.123C51.5223 58.0497 52.2277 57.9126 52.9166 57.7134L54.5486 60.1911C54.8995 60.7229 55.6146 60.8707 56.1475 60.5214L60.2968 57.7861C60.8287 57.4352 60.9764 56.7201 60.6271 56.1871L59.0018 53.7095C59.4571 53.1581 59.8597 52.5652 60.2043 51.9387L63.1048 52.5334C63.7301 52.6633 64.3422 52.2618 64.4722 51.6366 64.4722 51.636 64.4724 51.6354 64.4725 51.6348L65.4768 46.772C65.6023 46.1426 65.1943 45.5305 64.565 45.4043Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00386 282 470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8275 33.4123C43.4661 33.4123 43.9837 32.8946 43.9837 32.2561L43.9837 29.2763C43.9837 27.2941 47.2345 25.9727 50.2737 25.9727 53.313 25.9727 56.5637 27.2941 56.5637 29.2763L56.5637 32.2561C56.5637 32.8946 57.0814 33.4123 57.72 33.4123 58.3586 33.4123 58.8762 32.8946 58.8762 32.2561L58.8762 29.2763C58.8762 26.8382 56.8941 25.1534 54.3371 24.3011 55.3598 23.2373 55.9203 21.8122 55.8964 20.3368L55.8964 18.8568C56.0469 15.7551 53.6545 13.1187 50.5528 12.9682 47.4512 12.8177 44.8148 15.2101 44.6643 18.3118 44.6555 18.4933 44.6555 18.6752 44.6643 18.8568L44.6643 20.3434C44.6433 21.8183 45.2034 23.2423 46.2236 24.3077 43.6666 25.16 41.6845 26.8448 41.6845 29.2829L41.6845 32.2627C41.688 32.8935 42.1966 33.4051 42.8275 33.4123ZM46.9636 20.3434 46.9636 18.8568C46.9636 17.0323 48.4426 15.5532 50.2671 15.5532 52.0916 15.5532 53.5707 17.0323 53.5707 18.8568L53.5707 20.3434C53.5707 22.1679 52.0916 23.647 50.2671 23.647 48.4426 23.647 46.9636 22.1679 46.9636 20.3434Z",
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00386 282 470)"
  })))), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Yu Gothic,Yu Gothic_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 16,
    transform: "translate(276.844 551)"
  }, "Excellence", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 16,
    x: -1.25003,
    y: -316
  }, "Experience")), /*#__PURE__*/React.createElement("path", {
    d: "M127.932 168.422C153.135 143.219 193.997 143.219 219.199 168.422L511.088 460.311C536.291 485.514 536.291 526.375 511.088 551.578L511.088 551.578C485.885 576.78 445.024 576.781 419.821 551.578L127.932 259.689C102.73 234.486 102.73 193.625 127.932 168.422Z",
    fill: "#7B899F",
    fillRule: "evenodd",
    fillOpacity: 0.25098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 213C122 184.281 145.057 161 173.5 161 201.943 161 225 184.281 225 213 225 241.719 201.943 265 173.5 265 145.057 265 122 241.719 122 213Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#0F203E",
    fontFamily: "Yu Gothic,Yu Gothic_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 29,
    transform: "translate(153.089 214)"
  }, "CX", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 14,
    x: -12.6667,
    y: 21
  }, "Customer")), /*#__PURE__*/React.createElement("path", {
    d: "M414 505.5C414 477.057 437.281 454 466 454 494.719 454 518 477.057 518 505.5 518 533.943 494.719 557 466 557 437.281 557 414 533.943 414 505.5Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#0F203E",
    fontFamily: "Yu Gothic,Yu Gothic_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 29,
    transform: "translate(444.913 507)"
  }, "OX", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 14,
    x: -12.42,
    y: 21
  }, "Operation")), /*#__PURE__*/React.createElement("path", {
    d: "M227 360C227 309.742 267.966 269 318.5 269 369.034 269 410 309.742 410 360 410 410.258 369.034 451 318.5 451 267.966 451 227 410.258 227 360Z",
    fill: "#1C7AAC",
    fillRule: "evenodd",
    fillOpacity: 0.231373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 360C254 324.102 282.878 295 318.5 295 354.122 295 383 324.102 383 360 383 395.898 354.122 425 318.5 425 282.878 425 254 395.898 254 360Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 359.5C277 336.58 295.804 318 319 318 342.196 318 361 336.58 361 359.5 361 382.42 342.196 401 319 401 295.804 401 277 382.42 277 359.5Z",
    fill: "#1C7AAC",
    fillRule: "evenodd",
    fillOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fontFamily: "Yu Gothic,Yu Gothic_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 24,
    transform: "translate(229.042 353)"
  }, "Purpose Driven", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24,
    x: 24.7533,
    y: 29
  }, "Leadership")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimple4X);
export default __webpack_public_path__ + "static/media/simple_4x.cf3274fd136b68fa0b5ffe6b207ea7be.svg";
export { ForwardRef as ReactComponent };